import { Slider } from '../Slider';

class SliderCards extends Slider {
}

SliderCards.defaultProps = {
  id: '',
  className: 'slider-cards',
  children: [],
  slickOptions: {
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: false,
    rows: 0,
    infinite: false,
    variableWidth: true,
  },
};

export { SliderCards };
